import MceIcon from "components/MceIcon";
import { Col, Divider, Row, Subtitle, Text } from "mondrian-react";
import { reportGA4 } from "utils/pushDataLayer";
import "./styles.scss";

export const ExclusiveOfferBanner = ({ title, description, url, icon }) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <Divider />
        </Col>
      </Row>

      <Row>
        <Col xs={12} className="mdn-u-marginBottom--xs">
          <Subtitle sm>Oferta por tempo limitado!</Subtitle>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
            onClick={() => reportGA4({ customTitle: "oferta_exclusiva" })}
          >
            <div className="exclusive-offer-banner-wrapper">
              <MceIcon md icon={icon} className="exclusive-offer-banner-icon" />

              <div className="exclusive-offer-banner-content">
                <Text body>{title}</Text>
                <Text xs>{description}</Text>
              </div>
            </div>
          </a>
        </Col>
      </Row>

      <Row>
        <Col xs={12} className="mdn-u-marginTop--xxs">
          <Divider />
        </Col>
      </Row>
    </>
  );
};
